import React from 'react'

export const BLOCK_DATA = [
  {
    title: '95%',
    body: <>Закрытие испытательного срока</>,
  },
  {
    title: '17%',
    body: <>Максимальная текучесть</>,
  },
  {
    title: '92%',
    body: (
      <>
        Вовлеченность сотрудников <br />
        (в том числе удаленных)
      </>
    ),
  },
]
